import React, { useEffect, useState } from "react"
import { Circle, GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api"
import moment from "moment"
import locale from "antd/es/date-picker/locale/pt_BR"
import { DatePicker } from "antd"
const { RangePicker } = DatePicker
import { Card, CardBody } from "../../components/Card"
import { ToggleButton } from "../../components/Button"
import { Label } from "../../components/Form"
import BurnedMarkerImage from "../../assets/icons/fire.svg"
import FarmerMarkerImage from "../../assets/icons/userLoc.svg"
import MarkerImage from "../../assets/icons/map-marker.svg"


import "./styles.scss"

function BurnedScreen({ points, setStartDate, setEndDate, dateValue, onlyMap }) {
  const [activeMarker, setActiveMarker] = useState(true)
  const [activeCircleRadius, setActiveCircleRadius] = useState(false)
  
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDrCT4gtavpJUTtJ2xU7UpcsRTEsfWKQ5k",
  })
  
  const [map, setMap] = React.useState(null)

  const center = {
    lat: -27.3437964,
    lng: -48.7201192,
  }

  const containerStyle = {
    width: "100%",
    height: onlyMap === false ? "650px" : "calc(100vh - 180px)",
  }
  
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return
    }
    setActiveMarker(marker)
  }
  
  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center)
    map.fitBounds(bounds)
    setMap(map)
  }, [])
  
  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  const onChange = (value, dateString) => {
    setStartDate(moment(dateString[0], "DD/MM/YYYY").format("YYYY-MM-DD"))
    setEndDate(moment(dateString[1], "DD/MM/YYYY").format("YYYY-MM-DD"))
  }
  
  const handleActiveCircleRadius = () => {
    setActiveCircleRadius((active) => !active)
  }

const WithoutLocation = () => {
  return isLoaded ? (
    <>
      <Card className="card-burned without">
        <div className="info_container">
        <img src={MarkerImage} />
          <span className="info_content_f">Geolocalização não registrada</span>
          <span className="info_content_s">O produtor(a) ainda não tem sua geolocalização registrada.</span>
        </div>
      
      </Card> 
      
    </>
  ) :
  <></>
  
}
  return isLoaded ? (
    <>
      <Card className={`card-burned`}>
        { !onlyMap &&
          <Card className="range-date-button">
              <>
                <Label label="Intervalo entre os focos">
                  <RangePicker
                    disabledDate={(current) => moment().add(-0, "days") <= current}
                    showToday
                    className="range-date"
                    locale={locale}
                    onChange={onChange}
                    format="DD/MM/YYYY"
                    />
                </Label>
                <Label label="Raio de Distância">
                  <ToggleButton
                    selected={activeCircleRadius}
                    handleSelected={handleActiveCircleRadius}
                    />
                </Label>
              </>
          </Card>
        }
          
        <CardBody>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={points[0] && points[0].positionFocus && points[0] && points[0].positionProducer}
              zoom={10}
              mapTypeId="satellite"
              onLoad={onLoad}
              onUnmount={onUnmount}
              onClick={() => setActiveMarker(null)}>
              {points &&
                points.map(({ id, nameProducer, positionProducer, circle, positionFocus }, index) => (
                  <>
                    <Marker
                      key={index}
                      icon={FarmerMarkerImage}
                      position={positionProducer}
                      onClick={() => handleActiveMarker(id)}>
                      {id && activeMarker === id && positionProducer ? (
                        <InfoWindow
                          key={`hover-${id}`}
                          onCloseClick={() => setActiveMarker(null)}
                          position={positionProducer}>
                          <>
                            <span style={{ fontSize: "1.1rem" }}>Produtor:</span>
                            <div>{nameProducer}</div>
                          </>
                        </InfoWindow>
                      ) : (
                        <></>
                      )}
                    </Marker>
                    {activeCircleRadius && !isNaN(positionFocus.lat) && (
                      <Circle
                        center={positionProducer}
                        radius={circle.radius}
                        options={circle.options}
                      />
                    )}
                  </>
                ))}
              ,
              {points.map(({ nameCity, positionFocus, distanceFocus }, index) => (
                <Marker
                  key={index}
                  icon={BurnedMarkerImage}
                  position={positionFocus}
                  onClick={() => handleActiveMarker(index)}>
                  {index && activeMarker === index ? (
                    <InfoWindow
                      key={`hover-${index}`}
                      onCloseClick={() => setActiveMarker(null)}
                      position={positionFocus}>
                      <>
                        <span style={{ fontSize: "1.1rem" }}>Municipio do Foco de Calor:</span>
                        <div>{nameCity}</div>
                        <p></p>
                        <span style={{ fontSize: "1.1rem" }}>Distancia do Produtor:</span>
                        <div>{distanceFocus / 1000} Metros</div>
                      </>
                    </InfoWindow>
                  ) : (
                    <></>
                  )}
                </Marker>
              ))}
            </GoogleMap>
          </CardBody>
          {
            !onlyMap &&
            <div className="copyright-card">
              <p className="copyright-card__title">Direitos autorais:</p>
              <p className="copyright-card__description">
                Use estes dados livremente, mas citando a fonte:
                <br />
                INPE - Instituto Nacional de Pesquisas Espaciais, 2020. Portal do Monitoramento de
                Queimadas e Incêndios Florestais.
                <br />
                Disponível em <a href="http://www.inpe.br/queimadas">http://www.inpe.br/queimadas</a>.
                Acesso em: {moment().subtract(1, "days").format("DD/MM/YYYY")}
              </p>
            </div>
          }

      </Card>
    </>
  ) : (
    <></>
  )
}

export default React.memo(BurnedScreen)
